import React from "react";
import { Drawer, Descriptions, Typography } from "antd";
import "./GenericModal.css"; // Import the CSS file

const { Text } = Typography;

const GenericViewModal = ({ isVisible, data, title, handleCancel }) => {
  // Helper function to format labels
  const formatLabel = (label) =>
    label.charAt(0).toUpperCase() + label.slice(1).replace(/_/g, " ");

  // Recursive function to handle nested objects and arrays
  const renderContent = (value) => {
    if (typeof value === "object" && value !== null) {
      if (Array.isArray(value)) {
        return (
          <ul style={{ paddingLeft: "20px" }}>
            {value.map((item, index) => (
              <li key={index} style={{ color: "#e0e0e0" }}>
                {renderContent(item)}
              </li>
            ))}
          </ul>
        );
      } else {
        return (
          <Descriptions column={1} size="small" bordered>
            {Object.keys(value).map((nestedKey) => (
              <Descriptions.Item
                key={nestedKey}
                label={<span style={{ color: "#8c2be4" }}>{formatLabel(nestedKey)}</span>} // Purple label
              >
                <span style={{ color: "#e0e0e0" }}>{renderContent(value[nestedKey])}</span> {/* Light text */}
              </Descriptions.Item>
            ))}
          </Descriptions>
        );
      }
    }
    return <span style={{ color: "#e0e0e0" }}>{value}</span>; // Light text for non-object values
  };

  return (
    <Drawer
      title={<span style={{ color: "#e0e0e0" }}>{title || "Details"}</span>} // Drawer title with light text
      placement="right"
      onClose={handleCancel} // Ensure this is triggered on close
      open={isVisible} // Use `open` instead of `visible` in Ant Design v4+
      width={400}
      bodyStyle={{
        backgroundColor: "#1a1a1a", // Dark background for drawer body
        color: "#e0e0e0", // Light text
      }}
      headerStyle={{
        backgroundColor: "#333", // Darker background for header
        color: "#e0e0e0", // Light text
      }}
    >
      {data ? (
        <Descriptions column={1} bordered>
          {Object.keys(data).map((key) => (
            <Descriptions.Item
              key={key}
              label={<span style={{ color: "#8c2be4" }}>{formatLabel(key)}</span>} // Purple label text
            >
              {renderContent(data[key])}
            </Descriptions.Item>
          ))}
        </Descriptions>
      ) : (
        <p style={{ color: "#e0e0e0" }}>No data available</p> // Light text for fallback message
      )}
    </Drawer>
  );
};

export default GenericViewModal;
